// Lets Tournament.js tell TournamentHeader.js "here's the current open/
// closed state of the page's one player-search box, and here's what
// clicking the header's search icon should do" - same shape as
// compactSearchBus, just for the tournament page's own consolidated search
// (one icon replacing the old per-tab search boxes) instead of the list
// pages' toolbar.
export const tournamentSearchSubscribers = new Set();

export const publishTournamentSearch = (state) => {
    tournamentSearchSubscribers.forEach(cb => cb(state));
};
